<template>
  <div
    v-if="!isEmpty"
    class="scales-list"
  >
    <scale
      v-if="hasGenderbias"
      :scale="scales.genderbias"
      label-left="Inclusive"
      label-right="Exclusive"
    />
  </div>
</template>
<script>
import Scale from './Scale.vue';

export default {
  name: 'ScalesBlock',
  components: { Scale },
  props: { scales: { type: Object, default: () => ({}) } },
  computed: {
    isEmpty() {
      return Object.keys(this.scales).length === 0;
    },
    hasGenderbias() {
      return this.scales.genderbias;
    },
  },
};
</script>
